/**
 * ActionRow — one choice in an ask-on-save dialog: icon, bold title, quiet
 * caption. Shared by the set fork prompt and the package save prompt.
 * For Media Devoted | Created By Ciro Autiero
 */

import type { FC, ReactNode } from 'react';

const ActionRow: FC<{
  icon: ReactNode;
  title: string;
  caption: ReactNode;
  /** Small right-aligned pill naming WHO the choice affects. */
  scope?: string;
  primary?: boolean;
  disabled: boolean;
  onClick: () => void;
}> = ({ icon, title, caption, scope, primary, disabled, onClick }) => (
  <button
    type="button"
    onClick={onClick}
    disabled={disabled}
    className={`flex w-full items-start gap-3 rounded-lg border p-3 text-left transition-colors disabled:opacity-60 ${
      primary
        ? 'border-primary/50 bg-primary/5 hover:bg-primary/10'
        : 'border-border hover:bg-muted/40'
    }`}
  >
    <span className="mt-0.5 shrink-0 text-muted-foreground">{icon}</span>
    <span className="min-w-0 flex-1">
      <span className="flex items-center justify-between gap-2">
        <span className="text-xs font-semibold">{title}</span>
        {scope ? (
          <span
            className={`shrink-0 rounded-full px-1.5 py-0.5 text-[10px] font-medium ${
              primary
                ? 'bg-primary/15 text-primary'
                : 'bg-muted text-muted-foreground'
            }`}
          >
            {scope}
          </span>
        ) : null}
      </span>
      <span className="mt-0.5 block text-[11px] leading-snug text-muted-foreground">
        {caption}
      </span>
    </span>
  </button>
);

export default ActionRow;
